<template>
  <div class="row mx-0 ps-3 pe-3 pe-md-0 py-4 border-top">
    <div class="input-group row pe-0">
      <div
        class="d-flex pe-0 justify-content-between justify-content-md-start align-items-center mb-1"
      >
        <label class="size-12" for="school_name">学校名</label>
        <span class="tag-thirdly size-10 ms-2">必須</span>
      </div>
    </div>
    <div class="row p-0">
      <div class="col-12 pe-0">
        <Field
          v-slot="{ field, errors }"
          v-model="resumeEducation.school_name"
          name="candidate_resume.school_name"
        >
          <input
            id="school_name"
            type="text"
            class="input-primary form-control size-14 bg-silver-primary p-0d8 border-0"
            placeholder="学校名をご入力ください。"
            v-bind="field"
            :class="{ 'is-invalid': !!errors.length }"
          />
          <ErrorMessage name="candidate_resume.school_name" class="invalid-feedback" />
        </Field>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ErrorMessage, Field } from 'vee-validate';
import { useResumeEducationStore } from '@/stores/resume-candidate/ResumeEducation.store';

const resumeEducation = useResumeEducationStore();
</script>
